import Link from "next/link";
import React from "react";
import { configuration } from "../helpers/config";
import { Constants } from "../helpers/constants";
import Image from "next/image";
// component to render different types of button based on type .

// CTA'S FOR WEBSITE
export default function LinkButton({
  type,
  buttontext,
  href,
  widthFull,
  Id,
  target,
  onClick,
  hideBorder,
  enableFocus,
  targets,
  fontManage,
  widthManage,
  btnWidth,
  iconImage,
  propsArrow,
}) {
  // check type to render specific button
  switch (type) {
    case "button_dark_arrow":
      return (
        <Link href={href ? href : ""} download passHref>
          <a
            onClick={onClick}
            id={Id}
            className={`button_dark_arrow group ${
              hideBorder && "border-0"
            } ${widthManage}`}
            target={target}
            tabIndex={enableFocus?-1:0}
          >
            <span
              className={`text-mobileMenu md:text-medium font-SuzukiPROBold group-hover:border-b-primary-blue whitespace-nowrap ${fontManage} normal-case`}
              style={{ color: fontManage?.color, fontSize: fontManage?.font }}
              id={Id}
            >
              {buttontext}
            </span>
            <div
              type="button"
              id={Id}
              className="group-hover:bg-primary-blue btnn"
              aria-label="Click for Next page"
              role="button"
              // Only focus this when enableFocus is true
              tabIndex={enableFocus ? 0 : -1}
              onKeyDown={(e) => {
                if (enableFocus && (e.key === "Enter" || e.key === " ")) {
                  e.preventDefault();
                  onClick?.(e); // optional: simulate click
                  if (href) {
                      window.location.href = href; // trigger navigation manually
                  }
                }
              }}      
            >
              <img src={`${configuration.IMG_STATIC_URL}assets/images/blue-arrow.svg`} alt="Click for Next page" style={{height:"15px",width:"15px"}} />
            </div>
          </a>
        </Link>
      );

    case "button_catalogue_arrow":
      return (
        <Link href={href ? href : ""} download passHref>
          <a
            onClick={onClick}
            target={target}
            className={`button_dark_arrow group ${
              hideBorder && "border-0"
            } ${widthManage}`}
          >
            <span
              className={`text-mobileMenu md:text-default font-suzukiBold group-hover:border-b-primary-blue ${fontManage}`}
              style={{ color: fontManage?.color, fontSize: fontManage?.font }}
            >
              {buttontext}
            </span>
            <div
              type="button"
              className="group-hover:bg-primary-blue btnn"
              aria-label="Click for Next page"
              role="button"
            >
              <img src={propsArrow} alt="Click for Next page" style={{height:"15px",width:"15px"}} />
            </div>
          </a>
        </Link>
      );
    case "button_dark_arrow_button":
      return (
      //   <a
      //   target={target}
      //   rel="noreferrer"
      //   href={href}
      //   className="w-full"
      // >
        <button
          className="button_dark_arrow"
          id={Id}
          style={{maxWidth: widthManage}}
          onClick={onClick}
          aria-label={`${buttontext}, Click for Next page`}
          role="button"
        >
          <span className="normal-case">{buttontext}</span>
          <div className="border-b-0 button_dark_arrow--text btn-drive">
          <img src={`${configuration.IMG_STATIC_URL}assets/images/blue-arrow.svg`} alt="Click for Next page" style={{height:"15px",width:"15px"}}/>
          </div>
        </button>
        // </a>
      );
    case "button_light_arrow":
      return (
        <Link href={href ? href : ""} download passHref>
          <a
            target={target}
            rel="noreferrer"
            className={`button_light_arrow group ${widthFull}`}
            id="homepageBannerCta"
            style={{color: fontManage?.color ? fontManage?.color :"#ffffff"}}
          >
            <span
              style={{ color: fontManage?.color, fontSize: fontManage?.font }}
              className={`text-mobileMenu md:text-default font-suzukiBold group-hover:border-b-invertednormal-case`}
            >
              {buttontext}
            </span>
            <div type="button" className="btnn2">
              <img src={`${configuration.IMG_STATIC_URL}assets/images/white-arrow.svg`} alt="Click for Next page" style={{height:"15px",width:"15px"}}/>
            </div>
          </a>
        </Link>
      );

    case "social__icon--twitter":
      return (
        <a href={href} target="_blank" rel="noreferrer" aria-label={Constants?.altTagsForSocialMediaIcons?.TWITTER || "Follow us on Twitter"} id={Id}>
          <div className="button_dark_arrow group"  id={Id}>
            <span className="normal-case group-hover:border-b-primary-blue md:text-medium" aria-hidden="true" id={Id}>
              {buttontext}
            </span>
            <div
             id={Id}
              type="button"
              className="group-hover:bg-primary-blue btnn"
              aria-label={buttontext}
              role="link"
              aria-hidden="true"
            >
              <img src={`${configuration.IMG_STATIC_URL}assets/images/twitterX.svg`} alt={Constants?.altTagsForSocialMediaIcons?.TWITTER || "Follow us on Twitter"} style={{ height: "20px", width: "20px" }}/>
            </div>
          </div>
        </a>
      );

    case "social__icon--linkedin":
      return (
        <a href={href} target="_blank" rel="noreferrer" aria-label={Constants?.altTagsForSocialMediaIcons?.LINKEDIN || "Follow us on Linkedin"} id={Id}>
          <div className="button_dark_arrow group"  id={Id}>
            <span className="normal-case group-hover:border-b-primary-blue md:text-medium" aria-hidden="true" id={Id}>
              {buttontext}
            </span>
            <div
             id={Id}
              type="button"
              className="group-hover:bg-primary-blue btnn"
              style={{ padding: "0" }}
              aria-label={buttontext}
              role="link"
              aria-hidden="true"
            >
              <img src={`${configuration.IMG_STATIC_URL}assets/images/linkedin.svg`} alt={Constants?.altTagsForSocialMediaIcons?.LINKEDIN || "Follow us on Linkedin"} style={{ height: "20px", width: "20px" }}/>
            </div>
          </div>
        </a>
      );
    case "social__icon--facebook":
      return (
        <a href={href} target="_blank" rel="noreferrer" aria-label={Constants?.altTagsForSocialMediaIcons?.FACEBOOK || "Follow us on Facebook"} id={Id}>
          <div className="button_dark_arrow group"  id={Id}>
            <span className="normal-case group-hover:border-b-primary-blue md:text-medium" aria-hidden="true" id={Id}>
              {buttontext}
            </span>
            <div
             id={Id}
              type="button"
              className="group-hover:bg-primary-blue btnn"
              style={{ padding: "0" }}
              role="link"
              aria-label={buttontext}
              aria-hidden="true"
            >
              <img src={`${configuration.IMG_STATIC_URL}assets/images/facebook.svg`} alt={Constants?.altTagsForSocialMediaIcons?.FACEBOOK || "Follow us on Facebook"} style={{ height: "20px", width: "20px", maxWidth:"20px" }} />
            </div>
          </div>
        </a>
      );

    case "social__icon--instagram":
      return (
        <a href={href} target="_blank" rel="noreferrer" aria-label={Constants?.altTagsForSocialMediaIcons?.INSTAGRAM || "Follow us on Instagram"} id={Id}>
          <div className="button_dark_arrow group"  id={Id}>
            <span className="normal-case group-hover:border-b-primary-blue md:text-medium" aria-hidden="true" id={Id}>
              {buttontext}
            </span>
            <div
             id={Id}
              type="button"
              className="group-hover:bg-primary-blue btnn"
              style={{ padding: "0" }}
              aria-label={buttontext}
              role="link"
              aria-hidden="true"
            >
              <img src={`${configuration.IMG_STATIC_URL}assets/images/instagram.svg`} alt={Constants?.altTagsForSocialMediaIcons?.INSTAGRAM || "Follow us on Instagram"} style={{ height: "20px", width: "20px",maxWidth:"20px"  }}/>
            </div>
          </div>
        </a>
      );
    case "button_slide_arrow_button":
      return (
        // <button className={`button_dark_arrow ${btnWidth}`}>
        <button className={`button_dark_arrows ${btnWidth}`} aria-label={buttontext}>
          <span className="normal-case">{buttontext}</span>
          <div className="border-b-0 button_dark_arrow--text btn-drive px-0 justify-end w-[30px]">
            <img src={iconImage} alt="Click for Next page" />
          </div>
        </button>
      );
    case "social__icon--youtube":
      return (
        <a href={href} target="_blank" rel="noreferrer" aria-label={Constants?.altTagsForSocialMediaIcons?.YOUTUBE || "Follow us on Youtube"} id={Id}>
          <div className="button_dark_arrow group"  id={Id}>
            <span className="normal-case group-hover:border-b-primary-blue md:text-medium" aria-hidden="true" id={Id}>
              {buttontext}
            </span>
            <div
             id={Id}
              type="button"
              className="group-hover:bg-primary-blue btnn"
              style={{ padding: "0" }}
              aria-label={buttontext}
              role="link"
              aria-hidden="true"
            >
              <img src={`${configuration.IMG_STATIC_URL}assets/images/youtube.svg`} alt={Constants?.altTagsForSocialMediaIcons?.YOUTUBE || "Follow us on Youtube"} style={{ height: "20px", width: "20px" }}/>
            </div>
          </div>
        </a>
      );

      case "social__icon--tiktok":
        return (
          <a href={href} target="_blank" rel="noreferrer" aria-label={Constants?.altTagsForSocialMediaIcons?.TIKTOK || "Follow us on TikTok"} id={Id}>
            <div className="button_dark_arrow group"  id={Id}>
              <span className="normal-case group-hover:border-b-primary-blue md:text-medium" aria-hidden="true" id={Id}>
                {buttontext}
              </span>
              <div
               id={Id}
                type="button"
                className="group-hover:bg-primary-blue btnn"
                style={{ padding: "0" }}
                aria-label={buttontext}
                role="link"
                aria-hidden="true"
              >
                <img src={`${configuration.IMG_STATIC_URL}assets/images/tiktok.svg`} alt={Constants?.altTagsForSocialMediaIcons?.TIKTOK || "Follow us on TikTok"} style={{ height: "20px", width: "20px" }}/>
              </div>
            </div>
          </a>
        );
      case "no_arrow_button":
          return (
            <Link href={href ? href : ""} download passHref>
              <a
                onClick={onClick}
                id={Id}
                className={`button_dark_arrow group f-button ${
                  hideBorder && "border-0"
                } ${widthManage}`}
                target={target}
              >
                <span
                  className={`uppercase text-mobileMenu md:text-default font-suzukiBold group-hover:border-b-primary-blue whitespace-nowrap ${fontManage}`}
                  style={{ color: fontManage?.color, fontSize: fontManage?.font, textAlign: "center", padding: "0px 0px" }}  
                  id={Id}
                >
                  {buttontext}
                </span>
                <div
                  type="button"
                  id={Id}
                  className="group-hover:bg-primary-blue btnn"
                  aria-label="Click for Next page"
                  role="button"
                  
                >
                  <Image src={iconImage} alt="Click for Next page" style={{height:"15px",width:"15px"}} />
                </div>
              </a>
            </Link>
          );
          case "primary_grad_button":
            return href ? (
              <a href={href?.startsWith("http") ? href : `https://${href}`} target={target} rel="noreferrer" id={Id} tabIndex={-1}>
                <button
                  id={Id}
                  type="button"
                  className="font-suzukiBold text-inverted uppercase w-[180px] h-[50px] primary-grad-button text-[13px]"
                  aria-label={buttontext}
                  role="link"
                >
                  {buttontext}
                </button>
              </a>
            ) : (
              <button
                id={Id}
                type="button"
                className="font-suzukiBold text-inverted uppercase w-[180px] h-[50px] primary-grad-button text-[13px]"
                aria-label={buttontext}
                onClick={onClick}
              >
                {buttontext}
              </button>
            );
 
            case "secondary_grad_button":
              return href ? (
                <a href={href?.startsWith("http") ? href : `https://${href}`} target={target} rel="noreferrer" id={Id} tabIndex={-1}>
                  <button
                    id={Id}
                    type="button"
                    className="font-suzukiBold uppercase w-[180px] h-[50px] text-[13px] secondary-grad-button"
                    aria-label={buttontext}
                    role="link"
                  >
                    {buttontext}
                  </button>
                </a>
              ) : (
                <button
                  id={Id}
                  type="button"
                  onClick={onClick}
                  className="font-suzukiBold uppercase w-[180px] h-[50px] text-[13px] secondary-grad-button"
                  aria-label={buttontext}
                  role="link"
                >
                  {buttontext}
                </button>
              );
            

            case "tertiary_button":
          return  href ?(
              <a
              href={href?.startsWith("http") ? href : `https://${href}`}
                id={Id}
                className={`button_dark_arrow group tertiary-parent max-w-full max-sm:max-w-[180px]`}
                target={target}
                tabIndex={0}
              >
                <span
                  className={`text-mobileMenu md:text-default font-suzukiBold p-3 group-hover:border-b-primary-blue group-focus:border-none whitespace-nowrap ${fontManage}`}
                  style={{ color: fontManage?.color, fontSize: fontManage?.font }}
                  id={Id}
                >
                  {buttontext}
                </span>
                <button
                  type="button"
                  id={Id}
                  className="group-hover:bg-primary-blue group-focus:border-none p-3 border-b-2"
                  aria-label="Click for Next page"
                  role="button"
                  tabIndex={-1}
                  
                >
                  <img src={`${configuration.IMG_STATIC_URL}assets/images/blue-arrow.svg`} alt="Click for Next page" style={{height:"17px",width:"15px"}} />
                </button>
              </a>
             
          
          )
          :
          
          <a
            onClick={onClick}
            id={Id}
            className={`button_dark_arrow group tertiary-parent`}
            tabIndex={0}
           
          >
            <span
              className={`text-mobileMenu md:text-default font-suzukiBold pl-3 group-hover:border-b-primary-blue group-focus:border-none whitespace-nowrap ${fontManage}`}
              style={{ color: fontManage?.color, fontSize: fontManage?.font }}
              id={Id}
            >
              {buttontext}
            </span>
            <div
              type="button"
              id={Id}
              className="group-hover:bg-primary-blue group-focus:border-none btnn"
              aria-label="Click for Next page"
              role="button"
              
            >
              <img src={`${configuration.IMG_STATIC_URL}assets/images/blue-arrow.svg`} alt="Click for Next page" style={{height:"15px",width:"15px"}} />
            </div>
          </a>
        
     
  
      }

      
}
